export default "__VITE_ASSET__NTltxXV$__"